const guildZone = `

From now on, each **guild leader** can register their guild at the **Guild Officer** and take up the **fight in the guild mines**. However, the **undead will not give up easily** and will attempt to reclaim the mines.

Enter your **new guild zone** and start the adventure, from **fighting monsters** to **gathering materials** and **upgrading your structures**.

![Guild Zone Entrance](assets/guide/01_Zone_Eingang_us.jpg)

---

### **Guild Manager**
- The **Guild Manager** is the central NPC for managing your guild zone.
- You can check the **level of all NPCs** in your guild.
- The Guild Manager can only be upgraded if all other NPCs match his level.
- Only the **Guild Leader** can upgrade the Guild Manager.

![Guild Manager](assets/guide/13_Manager_us.jpg)

---

### **Guild Bank**
- Each **level of the Guild Bank** increases storage capacity by **300**.
- Stores resources collected from the mine.
- Only the **Guild Leader** can upgrade the Guild Bank.

![Guild Bank](assets/guide/11_Bank_us.jpg)

---

### **Guild Market**
- Shop for **special guild-related items**.
- Each level unlocks **new items**.
- Only the **Guild Leader** can upgrade the market.

![Guild Market](assets/guide/15_Shop_us.jpg)

---

### **Guild Buffer**
- Provides **buffs** to guild members.
- Buff strength increases with **higher levels**.
- At **level 2**, world buffs can be rebuffed if missed.
- Only the **Guild Leader** can upgrade the buffer.

![Guild Buffer](assets/guide/18_Buffer_us.jpg)

---

### **Guild Blacksmith**
- Allows **resource exchange** from the mine.
- Convert **basic materials** into advanced crafting resources.
- Exchange **Ancient Artifacts** for random resources.
- Only the **Guild Leader** can upgrade the Blacksmith.

![Guild Blacksmith](assets/guide/09_Schmied_us.jpg)

---

### **Guild Mine**
- The heart of the guild zone, producing **monsters & mining resources**.
- Higher levels increase the number of monsters and resources:
  - **Level 1** = 1-2 monsters & 10 resources
  - **Level 2** = 2-4 monsters & 20 resources
  - **Level 3** = 3-6 monsters & 30 resources
  - **Level 4** = 4-8 monsters & 40 resources
  - **Level 5** = 5-10 monsters & 50 resources

- Summoning Stones **scale with Mine level**.
- Monsters **always drop Non-Dura Equipment & Raw Materials**.
- Only the **Guild Leader** can upgrade the mine.

![Guild Mine](assets/guide/07_Monster_us.jpg)

---

### **Upgrade System**
- **Required Resources:** Diamonds, crystal glass, wood, iron plates, stones.
- Resources **can only be obtained in the Guild Mine** (not tradable).
- **Diamonds** can be bought at the **Guild Market** or dropped by Golems.
- Only the **Guild Leader** can upgrade NPCs.

---

### **Guild Events**
- **Hourly events** in the Guild Mine.
- **Event 1 (xx:00 - xx:10):** Monster waves spawn.
- **Event 2 (xx:20 - xx:30):** Players must open chests before monsters appear.
- **Event 3 (xx:40 - xx:50):** More monster waves.

![Guild Event](assets/guide/guild_event.png)

---

### **Guild Dungeon**
- **Not yet activated** (planned for **Part 2**).
- Will be available in a future update.

---

Prepare for battle and claim dominance over the **Guild Zone**!`;

export default guildZone;
